module.exports = __webpack_public_path__ + "static/media/social.5d37b698.jpg";